const autoResizeTextarea = (event) => {
    const textarea = event.target;
    if (textarea && textarea.tagName === 'TEXTAREA') {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    }
};
document.querySelectorAll('.textarea--autoexpand').forEach((textarea) => {
    textarea.addEventListener('input', autoResizeTextarea);
});
